import React, {useState} from "react";
import {PageHeader} from "../../../components/PageHeader";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import ComputerListType from "./subPages/ComputerRoomListType";
import {selectComputerRoom} from "../../../api/computerRoom/ComputerRoomService";

function ComputerRoomList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook} =
        useRequestData(selectComputerRoom, initDate, "computer_room_list");



    return (
        <>
            <div className="common-container container-height-full">
                <PageHeader header={"전산실 출입관리"} indicator={"환경설정 > 방문관리 > 전산실 출입관리"} />
                <ComputerListType
                    data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}} />
            </div>
        </>
    );
}

export default ComputerRoomList;